import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface Vendor1099Row {
  vendor_id: string;
  vendor_name: string;
  ein: string | null;
  is_1099_eligible: boolean | null;
  w9_on_file: boolean | null;
  tax_classification: string | null;
  billing_address: string | null;
  billing_city: string | null;
  billing_state: string | null;
  billing_zip: string | null;
  tax_year: number;
  ytd_paid: number;
  exceeds_1099_threshold: boolean;
  w9_required_missing: boolean;
}

export const use1099Summary = (taxYear: number) => {
  const { user } = useAuth();

  return useQuery<Vendor1099Row[]>({
    queryKey: ["1099_summary", user?.id, taxYear],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("v_vendor_1099_summary")
        .select("*")
        .eq("tax_year", taxYear)
        .order("ytd_paid", { ascending: false });
      if (error) throw error;
      return (data ?? []) as unknown as Vendor1099Row[];
    },
    enabled: !!user,
  });
};

/** Returns vendors over $600 with no W9 — for banner warning */
export const use1099Warnings = () => {
  const { user } = useAuth();
  const currentYear = new Date().getFullYear();

  return useQuery<Vendor1099Row[]>({
    queryKey: ["1099_warnings", user?.id, currentYear],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("v_vendor_1099_summary")
        .select("*")
        .eq("tax_year", currentYear)
        .eq("w9_required_missing", true);
      if (error) throw error;
      return (data ?? []) as unknown as Vendor1099Row[];
    },
    enabled: !!user,
  });
};
